// extracted by mini-css-extract-plugin
module.exports = {"root":"ChessIcon_root__3I4Dk","icon":"ChessIcon_icon__3naqr"};